export const FILTER_PANEL_LOCALE_ZHCHS = {
    filter: 'ç­é',
    confirm: 'ç¡®å®',
    cancel: 'åæ¶',
    reset: 'æ¸ç©ºç­é',
    advancedFilter: 'æ´å¤ç­é',
    expand: 'å±å¼',
    fold: 'æ¶èµ·',
    last1Month: 'è¿ä¸æ',
    last3Month: 'è¿ä¸æ',
    last6Month: 'è¿åå¹´',
    pleaseInput: 'è¯·åå½å¥',
    searchHistory: 'åå²æç´¢',
    searchResult: 'æ¥è¯¢ç»æ',
    intervalFilter: 'æåºé´ç­é',
    beginPlaceHolder: 'æä½å¼',
    endPlaceHolder: 'æé«å¼',
    dateBeginPlaceHolder: 'å¼å§æ¥æ',
    dateEndPlaceHolder: 'ç»ææ¥æ',
    empty: 'éç½®',
    clear: 'æ¸ç©ºç­é',
    today:'å½å¤©',
    yesterday: 'æ¨å¤©',
    checkall: 'å¨é',
    searchPlaceHolder:'è¯·è¾å¥åç§°',
    operators: {
        equal: 'ç­äº',
        notEqual: 'ä¸ç­äº',
        greater: 'å¤§äº',
        greaterOrEqual: 'å¤§äºç­äº',
        less: 'å°äº',
        lessOrEqual: 'å°äºç­äº',
        contains: 'åå«',
        notContains: 'ä¸åå«',
        like:  'åå«',
        notLike: 'ä¸åå«',
        in: 'å±äº',
        notIn: 'ä¸å±äº',
        empty: 'ä¸ºç©º',
        notEmpty: 'ä¸ä¸ºç©º',
        null: 'Null',
        notNull: 'ä¸ä¸ºNull'
    }
};
